import React from 'react';
import { AgGridColumn } from '../../../components/agGridColumn';
import Grid from '../../../components/grid';
import {ActionProps} from '../../../components/gridAction';
import {booleanFormater} from "../../../components/gridUtils";

const PerfilList = () => {
    const actions: Array<ActionProps> = [
        {
            route:'perfil/incluir',
            color:'success',
            type:'normal',
            title:'Incluir'
        },
        {
            route:'perfil/alterar',
            color:'warning',
            type:'grid',
            title:'Alterar'
        },
        {
            route:'perfil/visualizar',
            color:'info',
            type:'grid',
            title:'Visualizar',
        },
        {
            // Perfil nao se exclui: inativado, deixa de valer para todos os usuarios dele.
            route:'perfil-privilegio/ativar-inativar',
            color:'secondary',
            type:'post',
            title:'Ativar/Inativar',
            callBackFunction: () => true,
        },
    ];

    return (
        <Grid actions={actions} rota="perfil-privilegio/list">
            <AgGridColumn width={110} sort="asc" headerName="#" checkboxSelection field="id" sortable={ true } filter={ 'agNumberColumnFilter'}></AgGridColumn>
            <AgGridColumn flex={2} headerName="Nome" field="nome" sortable={ true } filter={ true }></AgGridColumn>
            <AgGridColumn flex={1} headerName="Código" field="codigo" sortable={ true } filter={ true }></AgGridColumn>
            <AgGridColumn width={130} headerName="Usuários" field="usuarios" sortable={ false } filter={ false }></AgGridColumn>
            <AgGridColumn width={110} headerName="Ativo" field="ativo" sortable={ true } valueFormatter={booleanFormater}></AgGridColumn>
        </Grid>
    );
}

export default PerfilList;
